import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ChatRequest, ChatResponse, ProductRecommendationRequest, ProductRecommendationResponse } from 'src/app/models/dto/chat';

@Injectable({
  providedIn: 'root'
})
export class OpenAIService {

  private readonly urlApi = environment.url_api_v2;
  constructor(private http: HttpClient) { }

  sendChat(text: string) {
    const obj = {
      Text: text
    };
    const urlRegistro = this.urlApi + 'chat';

    const headers = { 'Content-Type': 'application/json' };
    return this.http.post(urlRegistro, JSON.stringify(obj), { headers });
  }

  sendMessage(body: ChatRequest) {
    const urlRegistro = this.urlApi + 'api/v2/chat/send';

    return this.http.post<ChatResponse>(urlRegistro, body);
  }

  getProductRecommendations(body: ProductRecommendationRequest) {
    const urlRegistro = this.urlApi + 'api/v2/productos/recomendaciones';

    return this.http.post<ProductRecommendationResponse>(urlRegistro, body);
  }

  lookForImages(img: string) {
    return this.http.post<any>(this.urlApi + 'api/v2/chat/identify-product', { imageUrl: img });
  }
}
